import { render, staticRenderFns } from "./BlockingPlushiesListPage.vue?vue&type=template&id=73224e03&scoped=true&"
import script from "./BlockingPlushiesListPage.vue?vue&type=script&lang=ts&"
export * from "./BlockingPlushiesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./BlockingPlushiesListPage.vue?vue&type=style&index=0&id=73224e03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73224e03",
  null
  
)

export default component.exports